import React from 'react';
import ReactDOM from 'react-dom';
import "./styles/theme.css";
import './styles/tailwind.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from "react-router-dom";
import ReactGA from 'react-ga';
import Constants from './services/constants';
ReactGA.initialize(Constants.GA_MEASURMENT_ID);

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
